
import { defineComponent } from "vue";
import SectionHeader from "@/components/Shared/SectionHeader/SectionHeader.vue";

export default defineComponent({
  name: "FooterSection",
  components: {
    SectionHeader,
  },
});
